import { read } from '@/utils/request';

import type { IMediaManagement } from './interface';

export const getMediaLists = async (params?: IMediaManagement.Request.MediaListReq) => {
  return read<IMediaManagement.Response.MediaListRes>(
    'application/media_management/select',
    params,
    undefined,
    undefined,
    {
      isCamel: false,
      isLower: false,
    },
  );
};
